import { Link } from "react-router-dom";
import { clips } from "@/mocks/siteData";
import SectionHeading from "@/components/feature/SectionHeading";
import Reveal from "@/components/base/Reveal";

export default function ClipsSection() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <SectionHeading
        eyebrow="Replay"
        title="名场面回放"
        desc="按片段整理的关键画面与现场回放，标好时长和类型，想看哪个瞬间直接点开。"
        action={
          <Link
            to="/category?cat=classic-moments"
            className="inline-flex items-center gap-1.5 h-10 px-4 rounded-md bg-foreground-950 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors"
          >
            <i className="ri-movie-2-line"></i>
            全部名场面
          </Link>
        }
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {clips.map((clip, index) => (
          <Reveal key={clip.id} delay={index * 60}>
            <Link to={`/article/${clip.id}`} className="group block">
              <div className="relative w-full aspect-video rounded-lg overflow-hidden bg-foreground-950">
                <img
                  src={clip.cover}
                  alt={clip.title}
                  className="w-full h-full object-cover object-top opacity-90 transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2 py-0.5 rounded bg-primary-500 text-background-50 text-[11px] whitespace-nowrap">
                  {clip.label}
                </span>
                <span className="absolute top-3 right-3 px-2 py-0.5 rounded bg-foreground-950/70 text-background-100 text-[11px] whitespace-nowrap">
                  {clip.duration}
                </span>
                <span className="absolute bottom-3 left-3 w-9 h-9 rounded-full bg-background-50/90 text-foreground-950 flex items-center justify-center transition-transform group-hover:scale-110">
                  <i className="ri-play-fill text-lg"></i>
                </span>
              </div>
              <h3 className="mt-3 text-sm font-medium text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                {clip.title}
              </h3>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
}